import * as React from 'react';
import LeftOpenBoxStore from './store';
import wrapStore from '../../../../utils/wrap-store';
import cx from 'classnames';
import aos from '@src/utils/aos';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import toWebpImage from '@src/utils/to-webp-image';
import Link from '@src/components/link';
const styles = require('./index.less');
const lang = getLanguageByPath() === 'zh-Hant' ? 'tc' : getLanguageByPath();

// 左侧展开卡片
const LeftOpenBox = ({ store }) => {
  store.use();
  const scrollContainerRef = React.useRef(null);
  React.useEffect(
    () => {
      // 将滚动容器 ref 传递给 store
      if (scrollContainerRef.current) {
        store.setScrollContainer(scrollContainerRef.current);
      }
      // 组件卸载时执行 store 的销毁逻辑
      return () => {
        store.destroyScrollListener();
      };
    },
    [store]
  );
  return (
    <div className={cx(styles.timelineleftcontainer)} {...aos.FADE_RIGHT()}>
      <div className={cx(styles.lefttitle_open)} style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/left-title-open.png`))})` }} />
      <div className={styles.timelinelist} id="jsjs_timeline_list" ref={scrollContainerRef}>
        {store.data?.map((item, index) => (
          <div
            key={index}
            className={styles.timelineitem_box}
            id={`jsjs_${index}`}
            onClick={() => {
              store.toDetail(item, index);
            }}
          >
            <div className={styles.timelineitem}>
              <div className={styles.imgBox}>
                <img src={item?.cover_image_url?.[0]?.url} alt={item?.title} />
              </div>
              <div className={styles.content}>
                <div className={styles.title}>
                  <div className={styles.titleText}>{item?.title}</div>
                  {/* 装饰线 + 序号 */}
                  <div className={styles.title_line}>
                    <div className={styles.icon1} />
                    <div className={styles.line_1}>
                      <div className={styles.line_2}>
                        <div className={styles.serial_num}>
                          <div className={styles.serial_num_text}>{item?.data}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.desc} dangerouslySetInnerHTML={{ __html: item?.description }} />
              </div>
            </div>
            {/* hover 效果 */}
            <div className={styles.hover_effect} />
          </div>
        ))}
        {/* scrollContainerRef 滚动差不多一屏的距离就显示按钮 */}
        {store.isShowBtn && (
          <Link
            className={styles.tooBtn}
            onClick={() => {
              // 点击按钮时平滑滚动到顶部
              scrollContainerRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }}
          />
        )}
      </div>
    </div>
  );
};

export default wrapStore(LeftOpenBox, LeftOpenBoxStore);
